import React, { Fragment } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import { useTranslation } from 'react-i18next';

import AdvertisementTypesTab from './advertisement-types-tab';
import ExpirationOptionsTab from './expiration-options-tab';
import CameraModesTab from './camera-modes-tab';
import CameraClassesTab from './camera-classes-tab';

const AdminSetting = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <CommonMetaTag />
      <Tabs
        defaultActiveKey="expiration_options"
        className="myvideo-tabs"
        style={{ marginTop: 100, marginLeft: 130, marginRight: 130 }}
        mountOnEnter
        unmountOnExit
      >
        <Tab eventKey="expiration_options" title={t('SETTINGS_EXPIRATION_OPTIONS') || 'Expiration Options'} tabClassName="myvideo-tab">
          <ExpirationOptionsTab />
        </Tab>
        <Tab eventKey="advertisement_types" title={t('SETTINGS_ADVERTISEMENT_TYPES') || 'Advertisement Types'} tabClassName="myvideo-tab">
          <AdvertisementTypesTab />
        </Tab>
        <Tab eventKey="camera_modes" title={t('SETTINGS_CAMERA_MODES') || 'Camera Modes'} tabClassName="myvideo-tab">
          <CameraModesTab />
        </Tab>
        <Tab eventKey="camera_classes" title={t('SETTINGS_CAMERA_CLASSES') || 'Camera Classes'} tabClassName="myvideo-tab">
          <CameraClassesTab />
        </Tab>
      </Tabs>
    </Fragment>
  );
};

export default AdminSetting;